/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import {
  Card
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import DateUtil from "./../../utils/Date";
import GoogleMapReact from "google-map-react";
import EventMarker from "./../../components/Marker/Event";
import RouteClusterMarker from "./../../components/Marker/RouteCluster";
import RouteMarker from "./../../components/Marker/Route";
import useSupercluster from "use-supercluster";

import { Creators as SimulatorsMapsActions } from "./../../store/ducks/simulatorsMaps";

import PatrimonyMapMenu from "./../PatrimonyMapMenu";
import PatrimonyMapMenuPositionsAction from "./../PatrimonyMapMenuPositionsAction";

//import PositionService from "./../../services/Position";

const EventEmitter = require("events");

//const PLAYER_PAUSE = 0;
const PLAYER_PLAY = 1;
const PLAYER_STOP = -1;

const PatrimonyMap = ({
  trackerOptions,
  props: {
    currentUser,
    routes
  },
  funcs: {
    addNewRoute,
    addRouteEvent,
    addRoutePosition,
    addRoutePositionTransmissionQueue,
    addRoutePositionTransmissionOffQueue,
    removeRouteEvent,
    removeRoutePosition,
    resetRoutePositionTransmissionOffQueue,
    resetRoute,
    setRouteAction,
    setRouteInterval,
    setRoutePath,
    setRouteParams,
    setRoutePolyline,
    updateRouteEvent,
    updateRoutePosition
  }
}) => {
  const { t } = useTranslation();

  const {
    hatch: __hatch = "",
    niple: __niple = "",
    tracker: __tracker = "",
    rs232: __rs232 = false
  } = trackerOptions;

  const __default_center__ = { lat: -14.2800653, lng: -46.9647527 };
  const __default_zoom__ = 4.78;
  const __default_min_zoom__ = 3;
  const __default_max_zoom__ = 19;
  const __default_cluster_max_zoom__ = 18;

  const mapRef = useRef();
  const mapsRef = useRef();

  const [bounds, setBounds] = useState(null);
  //const [mapBounds, setMapBounds] = useState(false);
  const [mapReady, setMapReady] = useState(false);
  const [routeEmitter] = useState(new EventEmitter());
  const [routeId] = useState(`sp-route-${DateUtil.uniqid()}`);
  const [routeTrackers] = useState({
    hatch: __hatch,
    niple: __niple,
    tracker: __tracker,
    rs232: __rs232
  });

  const [options] = useState({
    mapTypeId: "DEF",
    minZoom: __default_min_zoom__,
    maxZoom: __default_max_zoom__,
    restriction: null,
    styles: [{
      stylers: [{
        saturation: -10
      }]
    }]
  });
  const [zoom, setZoom] = useState(12);

  const checkRouteApnConnect = (latLng) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      let connected = "CON";
      const routeBackgroundDisconnected = simulatorRoute.routePolyline.routeBackgroundDisconnected;
      routeBackgroundDisconnected.map(dis => {
        if (mapsRef.current.geometry.poly.isLocationOnEdge(
          latLng,
          dis
        )) {
          connected = "DIS";
        }
        return connected;
      });
      return connected;
    }
    return "NOT";
  };

  const checkRouteEvent = (latLng) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const routeBackgroundEvent = simulatorRoute.routePolyline.routeBackgroundEvent;
      const routeBackgroundEventDetected = [];
      routeBackgroundEvent.map((ev, index) => {
        if (mapsRef.current.geometry.spherical.computeDistanceBetween(latLng, ev.circle.getCenter()) <= ev.circle.getRadius()) {
          routeBackgroundEventDetected.push(ev);
          simulatorRoute.routePolyline.routeBackgroundEvent.splice(index, 1);
        }
        return ev;
      });
      return routeBackgroundEventDetected;
    }
    return [];
  };

  const generateRouteToMap = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const polylinePath = simulatorRoute.routePolyline.routePathEncoded;
      const polylineEncoded = atob(polylinePath);
      const polyline = getRoutePolyline(mapsRef.current.geometry.encoding.decodePath(polylineEncoded)); //.slice(0, 100)
      const polylineBounds = new mapsRef.current.LatLngBounds();

      polyline.map(item => polylineBounds.extend(
        new mapsRef.current.LatLng(
          item.lat(),
          item.lng()
        )
      ));

      let polylineBackgroundBorder = new mapsRef.current.Polyline({
        path: polyline,
        geodesic: true,
        strokeColor: "#b50e0e",
        strokeWeight: 10
      });

      let polylineBackground = new mapsRef.current.Polyline({
        path: polyline,
        geodesic: true,
        strokeColor: "#ffffff",
        strokeWeight: 5
      });

      mapsRef.current.event.addListener(polylineBackground, "insert_at", function polylineChanged(evt) {
        polylineBackgroundBorder.setPath(polylineBackground.getPath());
      });
      mapsRef.current.event.addListener(polylineBackground.getPath(), "remove_at", function polylineChanged(evt) {
        polylineBackgroundBorder.setPath(polylineBackground.getPath());
      });
      mapsRef.current.event.addListener(polylineBackground.getPath(), "set_at", function polylineChanged(evt) {
        polylineBackgroundBorder.setPath(polylineBackground.getPath());
      });

      mapsRef.current.event.addListener(polylineBackground, "contextmenu", (e) => {
        const path = polylineBackground.getPath();
        const vertex = e.vertex;
        if (!path || vertex === undefined) {
          return;
        }
        path.removeAt(vertex);
        polylineBackgroundBorder.setPath(polylineBackground.getPath());
      });

      let polylineBackgroundComplete = new mapsRef.current.Polyline({
        path: [],
        geodesic: true,
        strokeColor: "#f45f5f",
        strokeWeight: 5,
        icons: [
          {
            icon: {
              fillColor: "#b50e0e",
              path: mapsRef.current.SymbolPath.FORWARD_OPEN_ARROW,
              scale: 1.2,
              strokeColor: "#b50e0e",
              strokeWeight: 2
            },
            offset: "20px",
            repeat: "50px"
          }
        ]
      });

      let polylineBackgroundDisconnected = new mapsRef.current.Polyline({
        map: mapRef.current,
        path: polyline.slice(9, 65),
        geodesic: true,
        strokeColor: "#fca130",
        strokeWeight: 5
      });

      let polylineBackgroundDisconnected2 = new mapsRef.current.Polyline({
        map: mapRef.current,
        path: polyline.slice(82, 95),
        geodesic: true,
        strokeColor: "#fca130",
        strokeWeight: 5
      });

      polylineBackground.setMap(mapRef.current);
      polylineBackgroundBorder.setMap(mapRef.current);
      polylineBackgroundComplete.setMap(mapRef.current);

      setRoutePolyline(routeId, "routeBackground", polylineBackground);
      setRoutePolyline(routeId, "routeBackgroundBorder", polylineBackgroundBorder);
      setRoutePolyline(routeId, "routeBackgroundComplete", polylineBackgroundComplete);
      setRoutePolyline(routeId, "routeBackgroundDisconnected", [polylineBackgroundDisconnected, polylineBackgroundDisconnected2]);
      setRoutePolyline(routeId, "routeBackgroundEvent", [
        // {
        //   circle: new mapsRef.current.Circle({
        //     strokeColor: "#FF0000",
        //     strokeOpacity: 0.8,
        //     strokeWeight: 2,
        //     fillColor: "#FF0000",
        //     fillOpacity: 0.35,
        //     map: mapRef.current,
        //     center: new mapsRef.current.LatLng(-27.100224153731933, -52.614346490738896),
        //     radius: 10
        //   }),
        //   type: "ignitionOn"
        // },
        // {
        //   circle: new mapsRef.current.Circle({
        //     strokeColor: "#FF0000",
        //     strokeOpacity: 0.8,
        //     strokeWeight: 2,
        //     fillColor: "#FF0000",
        //     fillOpacity: 0.35,
        //     map: mapRef.current,
        //     center: new mapsRef.current.LatLng(-27.099580440244544, -52.611412571037384),
        //     radius: 10
        //   }),
        //   type: "ignitionOff"
        // },
        // {
        //   circle: new mapsRef.current.Circle({
        //     strokeColor: "#FF0000",
        //     strokeOpacity: 0.8,
        //     strokeWeight: 2,
        //     fillColor: "#FF0000",
        //     fillOpacity: 0.35,
        //     map: mapRef.current,
        //     center: new mapsRef.current.LatLng(-27.09922559311768, -52.609966342355165),
        //     radius: 10
        //   }),
        //   type: "ignitionOn"
        // },
        // {
        //   circle: new mapsRef.current.Circle({
        //     strokeColor: "#FF0000",
        //     strokeOpacity: 0.8,
        //     strokeWeight: 2,
        //     fillColor: "#FF0000",
        //     fillOpacity: 0.35,
        //     map: mapRef.current,
        //     center: new mapsRef.current.LatLng(-27.098670000000002, -52.609840000000005),
        //     radius: 10
        //   }),
        //   type: "discharge"
        // }
      ]);

      setRoutePolyline(routeId, "routePath", polyline);

      if (polyline.length > 0) {
        mapRef.current.fitBounds(polylineBounds);
      }
    }
  };

  const getBounds = () => {
    if (mapReady) {
      const pointsBounds = new mapsRef.current.LatLngBounds();
      if (getRouteSource().length > 0) {
        getRouteSource().map(rs => (
          pointsBounds.extend(new mapsRef.current.LatLng(
            rs.position.gps.coordinate.latitude,
            rs.position.gps.coordinate.longitude
          )))
        );
        return pointsBounds;
      }
      else {
        mapRef.current.setCenter(__default_center__);
        mapRef.current.setZoom(__default_zoom__);
      }
    }
    return false;
  };

  const getMapTypeId = ({ type }) => {
    switch(type) {
    case "SAT":
      return "hybrid";
    default:
      return "roadmap";
    }
  };

  const getRoute = () => {
    const route = routes.find(x => x.id === routeId);
    if (route) {
      return route;
    }
    return false;
  };

  const getRouteAction = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeAction;
    }
    return false;
  };

  const getRouteCourse = (latLngA, latLngB) => {
    return mapsRef.current.geometry.spherical.computeHeading(latLngA, latLngB);
  };

  const getRouteCursor = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routePositions.find(x => x.id === "sp-cursor");
    }
    return false;
  };

  const getRouteDistance = (path = false) => {
    if (path !== false) {
      let distance = 0;
      path.map((v, i) => {
        if ((i + 1) < path.length) {
          distance += mapsRef.current.geometry.spherical.computeDistanceBetween(v, path[i + 1]);
        }
        return distance;
      });
      return distance;
    }
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.distance;
    }
    return 0;
  };

  const getRouteDistanceCurrentPoint = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const distance = getRouteDistance();
      const distanceCurrentPoint = getRouteDurationCurrentPoint() * getRouteMetersPerSecond();
      if (distanceCurrentPoint >= distance) {
        return distance;
      }
      return distanceCurrentPoint;
    }
    return 0;
  };

  const getRouteDistanceNextPoint = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const distance = getRouteDistance();
      const distanceNextPoint = getRouteDurationNextPoint() * getRouteMetersPerSecond();
      if (distanceNextPoint >= distance) {
        return false;
      }
      return distanceNextPoint;
    }
    return 0;
  };

  const getRouteDuration = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return getRouteDistance() / getRouteMetersPerSecond();
    }
    return 0;
  };

  const getRouteDurationCurrentPoint = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const duration = getRouteDuration();
      const durationCurrentPoint = (getRouteRenderCount() * getRouteRenderTime());
      if (durationCurrentPoint >= duration) {
        return duration;
      }
      return durationCurrentPoint;
    }
    return 0;
  };

  const getRouteDurationNextPoint = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const duration = getRouteDuration();
      const durationNextPoint = ((getRouteRenderCount() + 1) * getRouteRenderTime());
      if (durationNextPoint >= duration) {
        return duration;
      }
      return durationNextPoint;
    }
    return 0;
  };

  const getRouteEvents = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeEvents;
    }
    return [];
  };

  const getRouteEventClosed = (course, latitude, longitude) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const closedDate = new Date();
      return {
        id: `sp-niple-closed-${simulatorRoute.routePositions.length}`,
        gps: {
          course,
          latitude,
          longitude,
          reason: 8,
          speed: 0
        },
        nipleNetwork: {
          hatchs: [{
            date: closedDate,
            externalPower: false,
            gyroscope: {
              x: 0,
              y: 0,
              z: 0
            },
            niple: {
              connection: true,
              crc: true,
              last: {
                coordinate: {
                  latitude,
                  longitude
                },
                date: closedDate
              },
              serial: routeTrackers.niple
            },
            operation: "CLO",
            serial: routeTrackers.hatch,
            sensors: {
              distance: 21,
              greaterDistance: 22,
              shortestDistance: 20
            }
          }],
          niples: [{
            fraud: "WFL",
            gps: {
              coordinate: {
                latitude,
                longitude
              },
              date: closedDate
            },
            gyroscope: {
              x: 0,
              y: 0,
              z: 0
            },
            operation: "CLO",
            sensors: {
              charge: true,
              discharge: true,
              defaultHead: false,
              defaultPosition: false
            },
            serial: routeTrackers.niple,
            test: "TPW"
          }]
        },
        tracker: {
          ignition: getRouteIgnition(),
          serial: routeTrackers.niple
        },
        type: "nipleClosed"
      }
    }
    return false;
  };

  const getRouteEventDischarge = (course, latitude, longitude) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const dischargeDate = new Date();
      return {
        id: `sp-niple-discharge-${simulatorRoute.routePositions.length}`,
        gps: {
          course,
          latitude,
          longitude,
          reason: 8,
          speed: 0
        },
        nipleNetwork: {
          hatchs: [{
            date: dischargeDate,
            externalPower: false,
            gyroscope: {
              x: 0,
              y: 0,
              z: 0
            },
            niple: {
              connection: true,
              crc: true,
              last: {
                coordinate: {
                  latitude,
                  longitude
                },
                date: dischargeDate
              },
              serial: routeTrackers.niple
            },
            operation: "CLO",
            serial: routeTrackers.hatch,
            sensors: {
              distance: 21,
              greaterDistance: 22,
              shortestDistance: 20
            }
          }],
          niples: [{
            fraud: "WFL",
            gps: {
              coordinate: {
                latitude,
                longitude
              },
              date: dischargeDate
            },
            gyroscope: {
              x: 0,
              y: 0,
              z: 0
            },
            operation: "DIS",
            sensors: {
              charge: true,
              discharge: false,
              defaultHead: false,
              defaultPosition: false
            },
            serial: routeTrackers.niple,
            test: "TPW"
          }]
        },
        tracker: {
          ignition: getRouteIgnition(),
          serial: routeTrackers.niple
        },
        type: "nipleDischarge"
      }
    }
    return false;
  };

  const getRouteEventIgnitionOff = (course, latitude, longitude) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return {
        id: `sp-ignition-off-${simulatorRoute.routePositions.length}`,
        gps: {
          course,
          latitude,
          longitude,
          reason: 7,
          speed: 0
        },
        tracker: {
          ignition: false,
          serial: routeTrackers.niple
        },
        type: "ignitionOff"
      }
    }
    return false;
  };

  const getRouteEventIgnitionOn = (course, latitude, longitude) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return {
        id: `sp-ignition-on-${simulatorRoute.routePositions.length}`,
        gps: {
          course,
          latitude,
          longitude,
          reason: 7,
          speed: 0
        },
        tracker: {
          ignition: true,
          serial: routeTrackers.niple
        },
        type: "ignitionOn"
      }
    }
    return false;
  };

  const getRouteEventTimeIntervalOn = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute && (getRouteStatus() === PLAYER_PLAY)) {
      if (getRouteDistanceCurrentPoint() !== getRouteDistance()) {
        // addRouteEvent(routeId, {
        //   id: "sp-timer-interval-on",
        //   reason: 1,
        //   type: "timeInterval"
        // });

        addRouteEvent(routeId, getRouteEventDischarge());

        // if (simulatorRoute.routePositions.length % 2) {
        //   addRouteEvent(routeId, getRouteEventDischarge());
        // }
        // else {
        //   addRouteEvent(routeId, getRouteEventClosed());
        // }

        return setTimeout(getRouteEventTimeIntervalOn, (getRouteTimeIntervalOn() * 1000));
      }
    }
  };

  const getRouteIgnition = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.ignition;
    }
    return false;
  };

  const getRouteMetersPerSecond = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return (getRouteSpeed() * getRouteScale()) / 3.6;
    }
    return 0;
  };

  const getRoutePoints = () => {
    return getRouteSource().map(rs => ({
      type: "Feature",
      properties: { cluster: false, position: rs },
      geometry: {
        type: "Point",
        coordinates: [
          parseFloat(rs.position.gps.coordinate.longitude),
          parseFloat(rs.position.gps.coordinate.latitude)
        ]
      }
    }));
  };

  const getRoutePosition = (position) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const {
        course,
        latitude,
        longitude,
        reason,
        speed
      } = position.gps;

      if (typeof position.nipleNetwork === "undefined") {
        position.nipleNetwork = {
          hatchs: [],
          niples: []
        };
      }

      const {
        hatchs,
        niples
      } = position.nipleNetwork;

      const {
        ignition,
        serial
      } = position.tracker;

      if (typeof position.trackersBackup === "undefined") {
        position.trackersBackup = [];
      }

      return {
        gps: {
          apnConnect: checkRouteApnConnect(new mapsRef.current.LatLng(latitude, longitude)),
          coordinate: {
            latitude,
            longitude
          },
          course: (course < 0 ? (course + 360) : course),
          date: new Date(),
          reason,
          speed: typeof speed !== "undefined" ? speed : getRouteSpeed()
        },
        id: position.id,
        nipleNetwork: {
          hatchs,
          niples
        },
        tracker: {
          ignition: typeof ignition !== "undefined" ? ignition : getRouteIgnition(),
          charging: false,
          jammer: false,
          roaming: true,
          serial
        },
        trackersBackup: position.trackersBackup,
        type: position.type
      };
    }
    return false;
  };

  const getRoutePositionSend = (position, rs232 = false) => {
    //PositionService.sendSimulator({ position, rs232, token: currentUser.token });
    console.log(JSON.stringify(position));
  };

  const getRoutePositions = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routePositions;
    }
    return [];
  };

  const getRoutePositionsTransmissionOffQueue = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routePositionsTransmissionOffQueue;
    }
    return [];
  };

  const getRoutePolyline = (path) => {
    const pathAux = [];
    path.map(latLng => {
      if (pathAux.findIndex(x => x.lat() === latLng.lat() && x.lng() === latLng.lng()) === -1) {
        pathAux.push(latLng);
      }
      return latLng;
    });
    return pathAux;
  };

  const getRouteRender = (previousPoint = false, previousPointIndex = 0, previousCourse = -1) => {
    const simulatorRoute = getRoute();
    if (simulatorRoute && (getRouteStatus() === PLAYER_PLAY)) {
      const cursor = getRouteCursor();
      const distanceCurrentPoint = getRouteDistanceCurrentPoint();
      const distanceNextPoint = getRouteDistanceNextPoint();
      const routeEvents = getRouteEvents();
      const routePositions = getRoutePositions();

      const currentPoint = simulatorRoute.routePolyline.routeBackground.GetPointAtDistance(distanceCurrentPoint);
      const currentPointIndex = simulatorRoute.routePolyline.routeBackground.GetPointAtDistanceIndex(distanceCurrentPoint);
      const nextPoint = distanceNextPoint !== false ? simulatorRoute.routePolyline.routeBackground.GetPointAtDistance(distanceNextPoint) : false;
      const previousToCurrent = simulatorRoute.routePolyline.routeBackground.GetPointInterval(previousPointIndex, currentPointIndex);
      const startToCurrent = simulatorRoute.routePolyline.routeBackground.GetPointAtDistance(distanceCurrentPoint, true);

      let currentCourse = previousCourse;
      let previousPointCompare = previousPoint;

      if (cursor) {
        const newPosition = JSON.parse(JSON.stringify(cursor.position));
        newPosition.gps.course = previousPoint ? getRouteCourse(previousPoint, currentPoint) : getRouteCourse(currentPoint, nextPoint);
        newPosition.gps.coordinate.latitude = currentPoint.lat();
        newPosition.gps.coordinate.longitude = currentPoint.lng();
        newPosition.gps.date = new Date();
        routeEmitter.emit("updateRoutePosition", newPosition);

        /*
          1 -> Time interval
          2 -> Curve
          3 -> Command sent
          4 -> Feed event
          5 -> Force test
          6 -> Force position
          7 -> Ignition event
          8 -> Niple event
          9 -> Test event
          10 -> ESP restarted
          11 -> Operation test event
          12 -> Back cover
          13 -> Hatch
          14 -> Device (Tracker)
          15 -> Operation test failure event
          96 -> Reverse geocode
          97 -> Driver
          98 -> Maintenance
          99 -> Gyroscope
          100 -> Delayed Location
        */
        if (routeEvents.length > 0 && routePositions.length > 0) {
          routeEvents.map(e => {

            const position = getRoutePosition(e.position);
            position.gps.course = currentCourse;
            position.gps.latitude = currentPoint.lat();
            position.gps.longitude = currentPoint.lng();

            routeEmitter.emit("addRoutePosition", position);
            // routeEmitter.emit("addRoutePosition", {
            //   id: `${e.position.id}-${routePositions.length}`,
            //   gps: {
            //     course: currentCourse,
            //     latitude: currentPoint.lat(),
            //     longitude: currentPoint.lng(),
            //     reason: e.position.reason,
            //     speed: getRouteSpeed()
            //   },
            //   tracker: {
            //     ignition: getRouteIgnition(),
            //     serial: routeTrackers.tracker
            //   },
            //   type: e.position.type
            // });
            return removeRouteEvent(routeId, e);
          });
        }

        if (previousPoint && previousToCurrent.length > 0) {
          previousToCurrent.map((pc, i) => {
            const eventDetected = checkRouteEvent(pc);
            if (eventDetected.length > 0) {
              eventDetected.map(ev => {
                let event = false;
                switch(ev.type) {
                  case "discharge":
                    event = getRouteEventDischarge(currentCourse, pc.lat(), pc.lng());
                    break;
                  case "ignitionOff":
                    event = getRouteEventIgnitionOff(currentCourse, pc.lat(), pc.lng());
                    break;
                  case "ignitionOn":
                    event = getRouteEventIgnitionOn(currentCourse, pc.lat(), pc.lng());
                    break;
                  default:
                    event = false;
                }
                if (event) {
                  return routeEmitter.emit("addRoutePosition", event);
                }
                return true;
              });
            }

            previousCourse = currentCourse;
            currentCourse = getRouteCourse(previousPointCompare, pc);
            if (previousCourse !== -1) {
              //let diffCourse = previousCourse - currentCourse;
              //diffCourse = diffCourse < 0 ? (diffCourse * -1) : diffCourse;
              // if (diffCourse > 45) {
              //   routeEmitter.emit("addRoutePosition", {
              //     id: `sp-course-${simulatorRoute.routePositions.length}`,
              //     gps: {
              //       course: currentCourse,
              //       latitude: previousPointCompare.lat(),
              //       longitude: previousPointCompare.lng(),
              //       reason: 2,
              //       speed: getRouteSpeed()
              //     },
              //     tracker: {
              //       ignition: getRouteIgnition(),
              //       serial: routeTrackers.tracker
              //     },
              //     type: "course"
              //   });
              // }
            }
            previousPointCompare = pc;
            return pc;
          });
        }
      }
      else {
        setRouteParams(routeId, "ignition", true);
        // routeEmitter.emit("addRoutePosition", {
        //   id: "sp-route-start",
        //   gps: {
        //     course: getRouteCourse(currentPoint, nextPoint),
        //     latitude: currentPoint.lat(),
        //     longitude: currentPoint.lng(),
        //     reason: 7,
        //     speed: 0
        //   },
        //   tracker: {
        //     ignition: getRouteIgnition(),
        //     serial: routeTrackers.tracker
        //   },
        //   type: "ignitionOn"
        // });

        routeEmitter.emit("addRoutePosition", {
          id: "sp-cursor",
          gps: {
            course: getRouteCourse(currentPoint, nextPoint),
            latitude: currentPoint.lat(),
            longitude: currentPoint.lng(),
            reason: 2,
            speed: getRouteSpeed()
          },
          tracker: {
            ignition: getRouteIgnition(),
            serial: routeTrackers.tracker
          },
          type: "course"
        });
      }

      simulatorRoute.routePolyline.routeBackgroundComplete.setPath(startToCurrent);
      if (distanceCurrentPoint !== getRouteDistance()) {
        setRouteParams(routeId, "renderCount", (getRouteRenderCount() + 1));
        setTimeout(() => getRouteRender(currentPoint, currentPointIndex, currentCourse), (getRouteRenderTime() * 1000));
      }
      else {
        setRouteParams(routeId, "ignition", false);

        // routeEmitter.emit("addRoutePosition", {
        //   id: "sp-route-end",
        //   gps: {
        //     course: getRouteCourse(previousPoint, currentPoint),
        //     latitude: currentPoint.lat(),
        //     longitude: currentPoint.lng(),
        //     reason: 7,
        //     speed: 0
        //   },
        //   tracker: {
        //     ignition: getRouteIgnition(),
        //     serial: routeTrackers.tracker
        //   },
        //   type: "ignitionOff"
        // });
      }
    }
  };

  const getRouteRenderCount = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.renderCount;
    }
    return 0;
  };

  const getRouteRenderTime = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.renderTime;
    }
    return 0;
  };

  const getRouteScale = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.scale;
    }
    return 0;
  };

  const getRouteSpeed = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.speed;
    }
    return 0;
  };

  const getRouteSource = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return JSON.parse(JSON.stringify(simulatorRoute.routePositions));
    }
    return [];
  };

  const getRouteTimeIntervalOn = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.timeIntervalOn / getRouteScale();
    }
    return 0;
  };

  const getRouteStatus = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return simulatorRoute.routeParams.status;
    }
    return PLAYER_STOP;
  };

  const getRouteStatusPlay = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return startRouteExecute();
    }
  };

  const getRouteStatusStop = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return startRouteExecuteReset();
    }
  };

  const removeRouteFromMap = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      const {
        routeBackground,
        routeBackgroundBorder,
        routeBackgroundComplete,
        routeBackgroundDisconnected,
        routeBackgroundEvent
      } = simulatorRoute.routePolyline;
      routeBackground.setMap(null);
      routeBackgroundBorder.setMap(null);
      routeBackgroundComplete.setMap(null);
      routeBackgroundDisconnected.map(m => m.setMap(null));
      routeBackgroundEvent.map(m => m.circle.setMap(null));
      setRoutePolyline(routeId, "routeBackground", false);
      setRoutePolyline(routeId, "routeBackgroundBorder", false);
      setRoutePolyline(routeId, "routeBackgroundComplete", false);
      setRoutePolyline(routeId, "routeBackgroundDisconnected", []);
      setRoutePolyline(routeId, "routeBackgroundEvent", []);
    }
  };

  const reloadBounds = () => {
    const bounds = getBounds();
    if (bounds) {
      mapRef.current.fitBounds(bounds);
    }
  };

  const startRoute = () => {
    removeRouteFromMap();
    addNewRoute(routeId);
    //setRoutePolyline(routeId, "routePathEncoded", "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");

    setRoutePolyline(routeId, "routePathEncoded", "cGBsZER6a2NgSUdhQFFrQU9tQUVdQUlVYUJBS0FLWW1CXXFDP0FAPz9BP0E/QT9BP0E/QT9BP0FBQT9BQT8/QUFBQT8/QUE/S3tAT31AS3tAS3lAQ09DT1FlQU9lQVNtQj9RQk9FT01BT0hDTk9CX0BGWUhBdEBGWkhIQ1NFVUBRP1tOQ0xFTkFQRUpESEBGQURVTV9AVW9CU2dBT3dAP0FAQT9BP0FBPz9BP0FBPz9BQT9JeUBLZUFRa0FPX0E/QT9BP0E/QT9BP0FBPz9BQUFNfUBPa0FPZUFNZUFRZUFRZUFNZ0FPY0FiQEl2QVc=");

    generateRouteToMap();
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      setRouteParams(routeId, "distance", getRouteDistance(simulatorRoute.routePolyline.routePath));
      setRouteParams(routeId, "renderCount", 1);
    }
  };

  const startRouteExecute = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      setTimeout(getRouteRender, (getRouteRenderTime() * 1000));
      setTimeout(getRouteEventTimeIntervalOn, (getRouteTimeIntervalOn() * 1000));
    }
  };

  const startRouteExecuteReset = () => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      return startRoute();
    }
  };

  const routeAction = mapReady ? getRouteAction() : false;
  const routePoints = mapReady ? getRoutePoints() : [];
  const { clusters: routeClusters, supercluster: routeSupercluster } = useSupercluster({
    points: routePoints,
    bounds,
    zoom,
    options: {
      radius: 75,
      maxZoom: __default_cluster_max_zoom__
    }
  });

  const routeStatus = getRouteStatus();
  useEffect(() => {
    const simulatorRoute = getRoute();
    if (simulatorRoute) {
      if (routeStatus === PLAYER_PLAY) {
        getRouteStatusPlay();
      }
      else if (routeStatus === PLAYER_STOP) {
        getRouteStatusStop();
      }
    }
  }, [routeStatus]); //eslint-disable-line

  return (
    <Card>
      <Card.Header>{t("Title.Map")}</Card.Header>
      <Card.Body className="reset-padding">
        <div className={"filter-map-container"}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_APP_GOOGLE_MAP_KEY,
              libraries: ["places", "geometry"]
            }}
            defaultCenter={__default_center__}
            defaultZoom={__default_zoom__}
            yesIWantToUseGoogleMapApiInternals
            options={{
              disableDefaultUI: true,
              mapTypeId: getMapTypeId({ type: options.mapTypeId }),
              minZoom: options.minZoom,
              maxZoom: options.maxZoom,
              restriction: options.restriction,
              styles: options.styles
            }}
            onGoogleApiLoaded={({ map, maps }) => {
              mapRef.current = map;
              mapsRef.current = maps;
              mapsRef.current.Polyline.prototype.GetPointAtDistance = function(metres, array = false) {
                if (metres === 0) return array ? [this.getPath().getAt(0)] : this.getPath().getAt(0);
                if (metres < 0) return false;
                if (this.getPath().getLength() < 2) return false;
                var dist=0;
                var olddist=0;
                for (var i=1; (i < this.getPath().getLength() && dist < metres); i++) {
                  olddist = dist;
                  dist += mapsRef.current.geometry.spherical.computeDistanceBetween(
                    this.getPath().getAt(i),
                    this.getPath().getAt(i-1)
                  );
                }
                if (dist < metres) {
                  return false;
                }
                var p1= this.getPath().getAt(i-2);
                var p2= this.getPath().getAt(i-1);
                var m = (metres-olddist)/(dist-olddist);
                if (array) {
                  const path = this.getPath().getArray().slice(0, i-1);
                  path.push(new mapsRef.current.LatLng(p1.lat() + (p2.lat()-p1.lat())*m, p1.lng() + (p2.lng()-p1.lng())*m));
                  return path;
                }
                return new mapsRef.current.LatLng(p1.lat() + (p2.lat()-p1.lat())*m, p1.lng() + (p2.lng()-p1.lng())*m);
              };
              mapsRef.current.Polyline.prototype.GetPointAtDistanceIndex = function(metres) {
                if (metres === 0) return 0;
                if (metres < 0) return -1;
                if (this.getPath().getLength() < 2) return false;
                var dist=0;
                for (var i=1; (i < this.getPath().getLength() && dist < metres); i++) {
                  dist += mapsRef.current.geometry.spherical.computeDistanceBetween(
                    this.getPath().getAt(i),
                    this.getPath().getAt(i-1)
                  );
                }
                if (dist < metres) {
                  return -1;
                }
                return i - 1;
              };
              mapsRef.current.Polyline.prototype.GetPointInterval = function(i, j) {
                const path = this.getPath().getArray();
                if ((i < 0) || (j >= path.length) || (i >= j)) return [];
                return path.slice(i, (j + 1));
              };
              setMapReady(true);
              startRoute();
              routeEmitter.on("addRoutePosition", e => {
                const position = getRoutePosition(e);
                addRoutePosition(routeId, position);
                if (position.gps.apnConnect === "CON") {
                  routeEmitter.emit("addRoutePositionTransmissionQueue", position);
                  getRoutePositionsTransmissionOffQueue().reverse().map(pos => {
                    return routeEmitter.emit("addRoutePositionTransmissionQueue", pos.position);
                  });
                  resetRoutePositionTransmissionOffQueue(routeId);
                }
                else {
                  routeEmitter.emit("addRoutePositionTransmissionOffQueue", position);
                }
              });
              routeEmitter.on("addRoutePositionTransmissionQueue", e => {
                const position = e;
                if (position.id !== "sp-cursor") {
                  addRoutePositionTransmissionQueue(routeId, position);
                  getRoutePositionSend(position, routeTrackers.rs232);
                }
              });
              routeEmitter.on("addRoutePositionTransmissionOffQueue", e => {
                const position = e;
                addRoutePositionTransmissionOffQueue(routeId, position);
              });
              routeEmitter.on("updateRoutePosition", e => {
                const position = e;
                position.position = getRoutePosition(e);
                updateRoutePosition(routeId, position);
              });
            }}
            onChange={({ zoom, bounds }) => {
              setZoom(zoom);
              setBounds([
                bounds.nw.lng,
                bounds.se.lat,
                bounds.se.lng,
                bounds.nw.lat
              ]);
            }}>
            {
              routeClusters.map((cluster, index) => {
                const [longitude, latitude] = cluster.geometry.coordinates;
                const {
                  cluster: isCluster,
                  point_count: pointCount
                } = cluster.properties;
                if (isCluster) {
                  return (
                    <RouteClusterMarker
                      key={`route-cluster-${cluster.id}`}
                      lat={latitude}
                      lng={longitude}
                      size={(20 + (pointCount / routePoints.length) * 20)}
                      count={pointCount}
                      onClick={() => {
                        const expansionZoom = Math.min(
                          routeSupercluster.getClusterExpansionZoom(cluster.id),
                          __default_max_zoom__
                        );
                        mapRef.current.setZoom(expansionZoom);
                        mapRef.current.panTo({ lat: latitude, lng: longitude });
                      }}
                    />
                  );
                }
                return (
                  <EventMarker
                    key={`route-position-${cluster.properties.position.id}`}
                    lat={latitude}
                    lng={longitude}
                    onClick={(action) => {
                      switch(action) {
                      case 0:
                        reloadBounds();
                        break;
                      case 1:
                        mapRef.current.setZoom(__default_max_zoom__);
                        mapRef.current.panTo({ lat: latitude, lng: longitude });
                        break;
                      case 2:
                        // let course = 0;
                        // let lastPositionIndex = -1;
                        // let lastPositionLen = routePositions.length;
                        // if (lastPositionLen > 2) {
                        //   lastPositionIndex = routePositions.findIndex(x => x.id === cluster.properties.position.id);
                        // }
                        removeRoutePosition(routeId, cluster.properties.position);
                        // if (routePositions.length >= 2 && (lastPositionIndex !== -1 && lastPositionIndex > 0 && lastPositionIndex < (lastPositionLen-1)) && typeof routePositions[lastPositionIndex] !== "undefined") {
                        //   const backPosition = routePositions[lastPositionIndex-1].position;
                        //   const nextPosition = routePositions[lastPositionIndex].position;
                        //   course = getRouteCourse(
                        //     backPosition.gps.coordinate.latitude,
                        //     backPosition.gps.coordinate.longitude,
                        //     nextPosition.gps.coordinate.latitude,
                        //     nextPosition.gps.coordinate.longitude
                        //   );
                        //   backPosition.gps.course = course;
                        //   updateRoutePosition(routeId, backPosition);
                        // }
                        reloadBounds();
                        //getRoutePolyline();
                        break;
                      default:
                        return false;
                      }
                    }}
                    eType={() => cluster.properties.position.type}
                    ePosition={cluster.properties.position.position}
                    profile={{
                      currentUser,
                      miniMarkers: false
                    }}
                  />
                );
              })
            }
            {
              routeAction ? (
                <RouteMarker
                  key={`route-action-${routeAction.id}`}
                  lat={routeAction.position.gps.coordinate.latitude}
                  lng={routeAction.position.gps.coordinate.longitude}
                  onClick={(e) => {}}
                  position={routeAction.position}
                />
              ) : null
            }
          </GoogleMapReact>
          <PatrimonyMapMenu options={{ routeId }} />
          <PatrimonyMapMenuPositionsAction options={{ routeId }} />
        </div>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    routes: state.simulatorsMaps.routes
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, SimulatorsMapsActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PatrimonyMap);
